export const clientCategoryRouteName = {
  index: "client-categories.index",
};

export const clientCategoryRoute = [
  {
    path: "/client-categories",
    name: clientCategoryRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "client_category",
      breadcrumbs: () => {
        return [{ title: "Client Category" }];
      },
    },
  },
];
